import axios from 'axios';
import { BLOG_CONFIG } from '../config/blog';

const instance = axios.create({
  //baseURL: `https://${process.env.REACT_APP_API_BASE_URL}`,
  timeout: 10000
});
//const originHeader = {
//  "x-origin-verify":  process.env.REACT_APP_ORIGIN_HEADER
//}

const sendEmail = async (data) => {
  try {
    const response = await instance.post('/send_email', data, {
      //crossDomain: true,
      //headers: originHeader
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const validateCaptcha = async (challenge) => {
  try {
    var data = {
      response: challenge
    }
    const response = await instance.post('/recaptcha', data, {
      //crossDomain: true,
      //headers: originHeader
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getPosts = async (cursor = null, limit = BLOG_CONFIG.POSTS_PER_PAGE) => {
  try {
    let url = `/posts?limit=${limit}`;
    if (cursor) {
      url += `&cursor=${encodeURIComponent(cursor)}`;
    }
    
    const response = await instance.get(url);
    
    // If your Lambda returns {body: "..."}, parse it
    if (response.data.body) {
      return JSON.parse(response.data.body);
    }
    
    return response.data;
  } catch (error) {
    console.error('Error fetching posts:', error);
    throw error;
  }
};

const getPost = async (id) => {
  try {
    const response = await instance.get(`/posts/${id}`);
    console.log('Raw API response for post:', response.data); // Debug log
    
    // Handle Lambda response format
    if (response.data.statusCode === 200 && response.data.body) {
      return JSON.parse(response.data.body);
    }
    
    // Handle direct object response
    if (response.data && typeof response.data === 'object') {
      return response.data;
    }
    
    // If neither format, throw error
    throw new Error('Unexpected response format');
  } catch (error) {
    console.error('Error fetching post:', error);
    throw error;
  }
};

const getPostsByCategory = async (category, cursor = null, limit = BLOG_CONFIG.POSTS_PER_PAGE) => {
  try {
    let url = `/posts?category=${encodeURIComponent(category)}&limit=${limit}`;
    if (cursor) {
      url += `&cursor=${encodeURIComponent(cursor)}`;
    }
    
    const response = await instance.get(url);
    console.log('Raw API response for category:', response.data);
    
    // Handle Lambda response format
    if (response.data.statusCode === 200 && response.data.body) {
      return JSON.parse(response.data.body);
    }
    
    // Handle direct object response
    if (response.data && typeof response.data === 'object') {
      return response.data;
    }
    
    // If neither format, throw error
    throw new Error('Unexpected response format');
  } catch (error) {
    console.error('Error fetching posts by category:', error);
    throw error;
  }
};

const getCategories = async () => {
  try {
    const response = await instance.get('/categories');
    console.log('Raw API response for categories:', response.data);
    
    // Handle Lambda response format
    if (response.data.statusCode === 200 && response.data.body) {
      return JSON.parse(response.data.body);
    }
    
    // Handle direct array response
    if (Array.isArray(response.data)) {
      return response.data;
    }
    
    // If neither format, throw error
    throw new Error('Unexpected response format');
  } catch (error) {
    console.error('Error fetching categories:', error);
    throw error;
  }
};

export {sendEmail, validateCaptcha, getPosts, getPost, getPostsByCategory, getCategories}